import React from 'react';
import ReactDOM from 'react-dom';

import {Provider} from 'mobx-react';

import store from './donnees/store';

import AppAros from './components/AppAros';

import { HistoryAdapter } from 'mobx-state-router';
import { createBrowserHistory } from 'history';

window.store = store;

const history = createBrowserHistory();

const historyAdapter = new HistoryAdapter(store.routerStore, history);
historyAdapter.observeRouterStateChanges();

ReactDOM.render(<Provider store={store}><AppAros store={store}/></Provider>, document.getElementById('root'));


// WEBPACK FOOTER //
// ./src/index.js